@if ({}; as STATE) {
  <section class="subscriber-advertiser-layout"></section>
}
